import SolutionCompanies from './SolutionCompanies';

export default SolutionCompanies;
